import { Injectable } from '@angular/core';

const CLEAR_CACHE_DEBOUNCE_TIME = 3000;

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private cache: { [key: string]: CacheEntry } = {};

  constructor() {}

  get(key: string): CacheEntry | null {
    return this.cache[key];
  }

  set(key: string, data: unknown, pending: boolean): void {
    this.cache[key] = {
      data,
      pending,
    };

    setTimeout(() => {
      delete this.cache[key];
    }, CLEAR_CACHE_DEBOUNCE_TIME);
  }

  isPendingRequest(key: string): any {
    const entry = this.cache[key];

    return entry ? entry.pending : false;
  }

  clearCache(): void {
    this.cache = {};
  }
}

interface CacheEntry {
  data?: unknown;
  pending?: boolean;
}
